export const portfolio_data= [
    {
      id : 1,
      imgSrc: 'assets/img/portfolio/specchassi.jpg',
      name: 'SPEECH ASSISTANCE FOR BLIND PEOPLE',
      category : 'Web App',
      url : '',
      tech : 'Python, OpenCv, Yolo , Image recognition',
      desc : 'Developed a speech assistance for individuals with visual impairments to enhance their perception. Identify and distinguish objects and individuals in the surrounding area. Inform visually impaired individuals using the voice assistant .',
    },
    {
      id : 2,
      imgSrc: 'assets/img/portfolio/mynews.jpg',
      name: 'News.com',
      category : 'website',
      url : '',
      tech : 'React.js , newsapi',
      desc : ' News.com is a simple react app created with react.js. It shows various news headlines of various categories in India. News are categorized according to their type for simplicity.',
    },
    {
      id : 3,
      imgSrc: 'assets/img/portfolio/crm.jpg',
      name: 'Employee and Company Management',
      category : 'web app',
      url : '',
      tech : 'Html,Css,Js,Php,PhpMyadmin',
      desc : ' This is a customer and retailer relationship management system. Also has a admin sytem to manage all the retailers.',
    },
    {
      id : 4,
      imgSrc: 'assets/img/portfolio/flipkart.png',
      name: 'BLOCKCHAIN BASED LOYALTY PROGRAM USING FUNGIBLE TOKENS',
      category : 'Blockchain | Web',
      url : '',
      tech : 'MERN, Soliidty, Ethers',
      desc : 'Re-Designed the conventional loyalty and rewards program to seamlessly integrate with blockchain technology. Used solidity to create smart contracts using ERC-20 token . Enhance program security and user access by integrating MetaMask for decentralized identity verification and cryptocurrency payments.',
    },
    {
      id : 5,
      imgSrc: 'assets/img/portfolio/ecocity.png',
      name: 'Eco-City-Revival',
      category : 'Game Applications',
      url : 'https://eco-city.itch.io/eco-city',
      tech : 'Love2d, Tiled',
      desc : ' Weve created a game known as Eco-City, where our character explores the city in search of damaged or disassembled renewable energy resources. The objective is to complete quests that involve restoring these energy sources. Upon successful renewal, players earn bonus points and gain access to valuable information related to energy sustainability',
    },
    {
      id : 6,
      imgSrc: 'assets/img/portfolio/mynote.png',
      name: 'My-Notes',
      category : 'website',
      url : '',
      tech : 'React.js,Mongo,Express,node',
      desc : ' This is a simple node app  have where user can create Account. Login and add his notes. Edit and delete notes. Used react-router,context and mongodb as a database.',
    },
    
]